import React, { Component } from "react";
import { BsyUtils } from '../../utils/Utils';
import BsyMsgBubble from "../BsyMsgBubble";
import imgType1 from "../../images/img_qiyehulian@2x.png";
import imgType2 from "../../images/img_lianjieshixiao@2x.png";
import "./index.css";

export default class BsyCorpCoopInvite extends Component {
    constructor(props){
        super(props);
        this.state = {
            status: window.dock_data.status
        }
    }
    changeStatus = () =>{
        let status = this.state.status;
        if(status >= 9){
            status = 0;
        }else{
            status = status + 1;
        }
        this.setState({status: status});
    }
    connectBtn = () =>{
        React.axios("/corp/accept_join",{key: window.dock_data.key}).then((res) =>{
            if(res.data.errcode === 0){
                this.setState({status: 2});
            }
        })
    }

    _switch_corp = (corpId) => {
        return () => {
            window.FX.Utils.ajax({
                url: "/dashboard/switch_corp",
                data: {
                    corpId: corpId
                }
            }, function (d, e) {
                window.location.reload();
            })
        }
    }

    changeTeam = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (window.FX.Utils.isQyWinxin() || window.FX.Utils.isDingding() || window.FX.Utils.isFeishu() || window.FX.STATIC.user.acctype === 'webapi') {
            //优化 上诉模式 只有一个团队时 返回 多个可以切换 外部联系人的情况zhxj210916
            if (window?.localDevInfo?.corps.length < 2) {
                return;
            }
        }
        const e = window.$(event.currentTarget);
        e.addClass("open");
        const currteam = BsyUtils._getTeamName(window.FX.STATIC.user.corpId);
        BsyMsgBubble({
            anchor: event.currentTarget,
            isAlone: true,
            contentHTML: () => {
                return (<div className="bby-team-center">
                    <div>
                        <div>
                            <div className="team-title">
                                <i className="icon-team-create" />
                                <span>{React.language('corp.owned')}</span>
                            </div>     
                            <div className="split-line"></div>
                            <ul className="menu-team">
                                <li className={"menu-item " + (window.FX.STATIC.corpId === window.FX.STATIC.user.corpId ? "select" : "")} onClick={this._switch_corp(window.FX.STATIC.user.corpId)} role={window.FX.STATIC.user.corpId} title={currteam}>
                                    <span>{currteam}</span>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div className="team-title">
                                <i className="icon-team-join" />
                                <span>{React.language('corp.joined')}</span>
                            </div>
                            <div className="split-line"></div>
                            <div className="teamRoll">
                                <ul className="menu-team">
                                    {
                                        window?.localDevInfo?.corps.map((val) => {
                                            if(!val.isSysManager){
                                                return <></>
                                            }
                                            return window.FX.STATIC.user.corpId !== val.id && <li className={"menu-item " + (window.FX.STATIC.corpId === val.id ? "select" : "")} onClick={this._switch_corp(val.id)} role={val.id} title={val.name}>
                                                <i className="icon-team-join-item" />
                                                <span>{val.name}</span>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>)
            },
            text4Cancel: null,
            text4Ok: null,
            minWidth: 320,
            width: 320,
            contentPadding: 0,
            edge: 200,
            hAdjust: 72,
            dockPosition: "left",
            // "marginTop":20,
            onClose: function () {
                e.removeClass("open");
                return !1;
            }
        })
    }

    goHome = () =>{
        window.location.href = window.rootDirectroy + "/";
    }

    acceptInvite = () =>{
        React.axios('/corp/join_link',{corp_id: window.dock_data.corp_id, key: window.dock_data.key}).then(res=>{
            this.setState({
                status: 7
            })
        })
    }

    editCorpUser = (user) =>{
        React.axios("/corp/dock/member/add",{
            user_id_list: user,
            host_corp_id_list:[],
            guest_corp_id_list: window.dock_data['corp_id'],
            key: window.dock_data['key'],
        }).then(res=>{
            if(window.isMobile){
                window.location.href = window.rootDirectroy + "/";
            }else{
                window.location.href =  window.rootDirectroy + "/corp/addressbook?referer_uri=" + window.location.origin + "/#corpCoop";
            }
            
        })
    }

    render(){
        const { status } = this.state;
        const currteam = BsyUtils._getTeamName(window.FX.STATIC.corpId);
        const that = this;
        return (
            <div className="BsyCorpCoopInvite">
                {/* 状态码：{status} */}
                <div className="invite-result">
                    {
                        status === 0 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img">
                                        <img src={imgType1} alt="" />
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("contact.corp.link.query.title", {name:window.dock_data.corp_name, productName: window._bby_config.site_name})}
                                        </div>
                                        <div className="tip-msg">
                                            {React.language('contact.corp.link.query.tip', {productName: window._bby_config.site_name})}
                                        </div>
                                    </div>
                                    <div className="content-tip-button">
                                        <div className="registered-btn tip-button" style={{marginRight: 16}} onClick={this.goHome}>
                                            <span>{React.language("contact.corp.link.query.login")}</span>
                                        </div>
                                        <div className="register-btn tip-button" onClick={this.goHome}>
                                            <span>{React.language("contact.corp.link.query.register")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 1 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img">
                                        <img src={imgType1} alt="" />
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("contact.corp.connect.query.title", {name:window.dock_data.corp_name, productName: window._bby_config.site_name})}
                                        </div>
                                        <div className="tip-msg">
                                            {React.language('contact.corp.connect.query.tip', {productName: window._bby_config.site_name})}
                                        </div>
                                    </div>
                                    <div className="content-tip-button">
                                        <div className="register-btn tip-button" onClick={this.connectBtn}>
                                            <span>{React.language("contact.corp.connect.establish")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 2 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img">
                                        <i className="icon-bsy-reportmenu-2"></i>
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("contact.corp.connect.success")}
                                        </div>
                                        <div className="tip-msg">
                                            <div className="msg-list">
                                                <div className="msg-item">
                                                    {React.language('contact.corp.connect.success.tip1', {productName: window._bby_config.site_name})}
                                                </div>
                                                <div className="msg-item">
                                                    {React.language('contact.corp.connect.success.tip2')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-tip-button">
                                        <div className="register-btn tip-button" style={{marginRight: 16}} onClick={()=>{
                                            if(window.isMobile){
                                                new window.FX.UserMamageUserSelect({
                                                    render: window.$("<div />").appendTo(window.$('body')),
                                                    departmentMap: [],
                                                    cuurdepartmentID: 1,
                                                    value: [],
                                                    limit: [],
                                                    onStopEdit: function (e2) {
                                                        let value = e2.value;
                                                        that.editCorpUser(value);
                                                        return !1
                                                    }
                                                });
                                            }else{
                                                const e = new window.FX.ConfirmDialog({
                                                    title: React.language("widget.user.listTitle"),
                                                    height: 586,
                                                    width: 966,
                                                    contentWidget: {
                                                        rowSize: [451],
                                                        colSize: [926],
                                                        padding: 15,
                                                        items: [[{
                                                            widgetName: "memberSelect",
                                                            type: "memberselectpane",

                                                            hasMenuType:false,
                                                            hasDock: false,
                                                            editable: !0,
                                                            roleEnable: 0,
                                                            departmentEnable: !1,
                                                            hasTeamManageBtn: !1,
                                                            outsiderMemberEnable: !1,
                                                            outsiderGroupEnable: !1,
                                                            value: [],
                                                        }]]
                                                    },
                                                    onOk: () => {
                                                        let dept = e.getWidgetByName("memberSelect");
                                                        let d1 = dept.getAllJsonValue();
                                                        that.editCorpUser(d1.users);
                                                        return !1
                                                    }
                                                });
                                                e.show()
                                            }
                                            
                                            
                                        }}>
                                            <span>{React.language("contact.corp.handover.set")}</span>
                                        </div>
                                        <div className="registered-btn tip-button" onClick={()=>{
                                            window.location.href = "/"
                                        }}>
                                            <span>{React.language("contact.corp.handover.set.not")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 3 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img">
                                        <i className="icon-bsy-reportmenu-2"></i>
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("contact.corp.has.connect.tip1",{name: window.dock_data.corp_name})}
                                        </div>
                                        <div className="tip-msg">
                                            {React.language('contact.corp.has.connect.tip2')}
                                        </div>
                                    </div>
                                    <div className="content-tip-button">
                                        <div className="register-btn tip-button" onClick={this.goHome}>
                                            <span>{React.language("iSee")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 4 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img" style={{width: 321}}>
                                        <img src={imgType2} alt="" />
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("link.failure")}
                                        </div>
                                        <div className="tip-msg">
                                            {React.language('contact.corp.connect.expired.tip')}
                                        </div>
                                    </div>
                                    <div className="content-tip-button">
                                        <div className="register-btn tip-button" onClick={this.goHome}>
                                            <span>{React.language("contact.learn.bs", {productName: window._bby_config.site_name})}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 5 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img">
                                        <i className="icon-bsy-reportmenu-2"></i>
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("corp.coop.contact.request.success.title")}
                                        </div>
                                        <div className="tip-msg">
                                            {React.language('corp.coop.contact.request.success')}
                                        </div>
                                    </div>
                                    <div className="content-tip-button">
                                        <div className="register-btn tip-button" onClick={this.goHome}>
                                            <span>{React.language("receiver.enter.homepage", {productName: window._bby_config.site_name})}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 6 && <div className="result-cont" style={{backgroundColor: "#F5F7FA"}}>
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content enquire" style={{width: 380, height: 200}}>
                                    <div className="content-title">
                                        <i className="icon-dingding-sso-help"></i>
                                        <span>{React.language('member.invite.accept.confirm',{inviter: window.dock_data.corp_name})}</span>
                                    </div>
                                    <div className="content-button" onClick={this.acceptInvite}>
                                        <span>{React.language('member.invite.accept')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 7 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img">
                                        <i className="icon-bsy-reportmenu-2"></i>
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("corp.joined1",{corp:window.dock_data.corp_name})}
                                        </div>
                                        {/* <div className="tip-msg">
                                            {React.language("wechat.official.account.follow.instruction", {productName: window._bby_config.site_name})}
                                        </div>
                                        <div className="tip-qrCode">

                                        </div> */}
                                    </div>
                                    <div className="content-tip-button">
                                        <div className="register-btn tip-button" onClick={this.goHome}>
                                            <span>{React.language("receiver.enter.homepage", {productName: window._bby_config.site_name})}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 8 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img" style={{width: 321}}>
                                        <img src={imgType2} alt="" />
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("contact.corp.connect.fail")}
                                        </div>
                                        <div className="tip-msg">
                                            <div className="msg-list">
                                                <div className="msg-item">
                                                    {React.language('contact.corp.connect.self.tip1')}
                                                </div>
                                                <div className="msg-item">
                                                    {React.language('contact.corp.connect.self.tip2')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-tip-button" style={{"flex-flow":"column"}}>
                                        <div className="team-manager" onClick={this.changeTeam} > <span>{currteam}</span><i className="icon-down1"></i></div>
                                        <div className="register-btn tip-button" onClick={this.goHome}>
                                            <span>{React.language("goHome")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        status === 9 && <div className="result-cont">
                            <div className="cont-header">
                                <div className="header-pane">
                                    <img src={window.dock_data.logo} alt={window._bby_config.site_name} />
                                    <span>{window._bby_config.site_name}</span>
                                </div>
                            </div>
                            <div className="cont-body">
                                <div className="body-content" style={{width: 680}}>
                                    <div className="content-tip-img" style={{width: 321}}>
                                        <img src={imgType2} alt="" />
                                    </div>
                                    <div className="content-tip-text">
                                        <div className="tip-title">
                                            {React.language("contact.corp.connect.fail")}
                                        </div>
                                        <div className="tip-msg">
                                            <div className="msg-list">
                                                <div className="msg-item">
                                                    {React.language('contact.corp.connect.member.tip1')}
                                                </div>
                                                <div className="msg-item">
                                                    {React.language('contact.corp.connect.member.tip2')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-tip-button" style={{"flex-flow":"column"}}>
                                        <div className="team-manager" onClick={this.changeTeam} > <span>{currteam}</span><i className="icon-down1"></i></div>
                                        <div className="register-btn tip-button" onClick={this.goHome}>
                                            <span>{React.language("goHome")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}